import React from 'react'
import {Button} from '@material-ui/core'
import {getField} from 'utils/api'
import {fields} from 'utils/enums/fields'
import Number from 'components/Number'
import Date from 'components/Date'
import Check from 'components/Check'
import Phone from 'components/Phone'
import Image from 'components/Image'
import Linked from 'components/Linked'
import Text from 'components/Text'

class Switcher extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			errors: []
		}
	}

	getFields = () => {
		const data = []
		
		this.props.fields.forEach(item => {
			const {fieldId, readonly, optional, mandatory, now, recipient, autocomplete} = item
			const field = getField(fieldId)

			if (fieldId === -1) {
				data.push({
					type: 'subtitle',
					value: item.subtitle
				})
			}

			if (field && !recipient && !autocomplete && !now) {
				const label = item.label ? item.label : field.singular
				const type = field.uiType
				const config = field.uiConfig
				const relation = type === fields.linked ? field.linkedRelation[0] : null
				const value = type === fields.linked ? this.props.record['c' + relation] ?
					this.props.record['c' + relation][0] : null : this.props.record['c' + fieldId]
				const valueText = type === fields.linked ? this.props.record['d' + fieldId] : ''
				const invalid = !!this.state.errors.find(error => error.fieldId === fieldId)

				data.push({
					fieldId,
					type,
					config,
					relation,
					value,
					valueText,
					label,
					readonly,
					optional,
					mandatory,
					now,
					invalid
				})
			}
		})

		return data
	}

    getElement = (data) => {
		const {fieldId, type, config, relation, value, valueText, label, readonly, invalid} = data

        switch (type) {
            case fields.number:
                return (
                    <Number
                        defaultValue={value}
                        label={label}
                        config={config}
                        fieldId={fieldId}
						readonly={readonly}
                        handleChange={this.props.handleChange}
						invalid={invalid}
                    />
                )

            case fields.datetime:
                return (
                    <Date
                        defaultValue={value}
                        label={label}
                        config={config}
						readonly={readonly}
						fieldId={fieldId}
                        handleChange={this.props.handleChange}
						invalid={invalid}
                    />
                )

            case fields.image:
                return (
                    <Image
						defaultValue={value}
						fieldId={fieldId}
                        label={label}
						readonly={readonly}
                        handleChange={this.props.handleChange}
						invalid={invalid}
                    />
                )

            case fields.phone:
                return (
					<Phone
						fieldId={fieldId}
						label={label}
						config={config}
						defaultValue={value}
						readonly={readonly}
						handleChange={this.props.handleChange}
						invalid={invalid}
					/>
                )

            case fields.linked:
                return (
                    <Linked
                        defaultValue={value}
                        handleChange={this.props.handleChange}
                        relation={relation}
                        fieldId={fieldId}
                        label={label}
						readonly={readonly}
						record={this.props.record}
						valueText={valueText}
						invalid={invalid}
                    />
                )

            case fields.check:
                return (
                    <Check
                        label={label}
                        defaultValue={value}
                        fieldId={fieldId}
						readonly={readonly}
                        handleChange={this.props.handleChange}
                    />
                )

            case fields.textarea:
                return (
                    <Text
                        defaultValue={value}
                        multiline
                        fieldId={fieldId}
                        label={label}
                        handleChange={this.props.handleChange}
                        readonly={readonly}
						invalid={invalid}
                    />
                )

			case 'subtitle':
                return (
                    <div dangerouslySetInnerHTML={{__html: value}} style={{fontSize: '30px', marginBottom: '30px'}} />
                )

            default:
                return (
					<Text
                        defaultValue={value}
                        label={label}
                        fieldId={fieldId}
						readonly={readonly}
                        handleChange={this.props.handleChange}
						invalid={invalid}
                    />
                )
        }
    }

	submitForm = (data) => {
		const errors = data.filter(item =>
			(item.type !== fields.number && item.type !== fields.check && !item.optional && !item.value) ||
			(item.mandatory && item.value === '0') ||
			(item.type === fields.number && item.value !== 0 && !item.value))

		if (errors.length) {
			this.setState({
				errors
			}, () => this.setScroll())
		} else {
			this.props.submitForm()
		}
	}

	setScroll = () => {
		const el = document.querySelector('[data-id]')
		el.scrollIntoView({behavior: 'smooth'})
	}

    render() {
		const {label} = this.props
		const data = this.getFields()
		
        return (
			<React.Fragment>
            	{data.map((field, index) =>
					<React.Fragment key={field.fieldId || index}>
						{this.getElement(field)}
					</React.Fragment>
				)}
				<Button onClick={() => this.submitForm(data)}
					color='primary' variant='contained' style={{alignSelf: 'flex-start'}}>
					{label.submit ? label.submit : 'Submit'}
				</Button>
            </React.Fragment>
        )
    }
}

export default Switcher
